module.exports = __webpack_public_path__ + "img/101.b00897c6.jpg";